import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Emitter } from "strict-event-emitter";

export type ValueRangeResult = {
  min: number
  max: number
  minPercent: number
  maxPercent: number
}

const THEHOLD = .15;

export default class ValueRange extends ComponentBase
{
  // change emmit while dragging, update emit after release
  emitter: Emitter<{ change: [result: ValueRangeResult], update: [result: ValueRangeResult]}>

  _minPercent: number = 0;
  _maxPercent: number = 1;

  _min: number = 0;
  _max: number = 0;

  _isInteger: boolean = true;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this.emitter = new Emitter();

    this._isInteger = this.$root.attr("value-type") === "integer";
    this._min = parseFloat(this.$root[0].dataset.min);
    this._max = parseFloat(this.$root[0].dataset.max);

    let $start = this.$root.find(".start"),
      $end = this.$root.find(".end"),
      $base = this.$root.find(".base"),
      $value = this.$root.find(".value");

    let ham = new Hammer($start[0], {});

    ham.get("pan").set({ direction: Hammer.DIRECTION_HORIZONTAL });

    setupDrag.call(this, $start, $end, $base, $value, THEHOLD);
    setupDrag.call(this, $end, $start, $base, $value, -THEHOLD);

  }

  setRange(minValue: number, maxValue: number)
  {
    this._min = minValue;
    this._max = maxValue;
    this.update(this._minPercent, this._maxPercent, true);
  }

  setValue(minPercent?: number, maxPercent?: number, updateNow: boolean = true)
  {
    // console.log(`min ${minPercent}, max ${maxPercent}`);
    
    if(minPercent === undefined && maxPercent === undefined)
    {
      this.update(0, 1, false, updateNow? "update": "change");
      this._minPercent = 0;
      this._maxPercent = 1;
    }
    else
    {
      this.update(minPercent, maxPercent, false, updateNow? "update": "change");
      this._minPercent = minPercent;
      this._maxPercent = maxPercent;
    }

    this._updateUI();
  }

  _updateUI()
  {
    let $start = this.$root.find(".start"),
    $end = this.$root.find(".end"),
    $value = this.$root.find(".value");

    let minP = this._minPercent * (1 - THEHOLD),
      maxP = THEHOLD + this._maxPercent * (1 - THEHOLD);

    $start.css("left", (minP * 100) + "%");
    $value.css("left", (minP * 100) + "%").css("width", ((maxP - minP) * 100) + "%");
    $end.css("left", (maxP * 100) + "%");
  }

  update(minPercent: number, maxPercent: number, forceUpdate: boolean = false, updateType: string = "update")
  {
    // console.log(`min: ${minPercent}, max: ${maxPercent}`);

    if(minPercent === undefined) minPercent = this._minPercent;
    if(maxPercent === undefined) maxPercent = this._maxPercent;

    let minValue = this._min + ((this._max - this._min) * minPercent),
      maxValue = this._min + ((this._max - this._min) * maxPercent);

    if(this._isInteger) {
      minValue = parseInt(minValue);
      maxValue = parseInt(maxValue);
    }

    let result: ValueRangeResult = 
    {
      minPercent: minPercent,
      maxPercent: maxPercent,
      min: minValue,
      max: maxValue
    };    

    this.emitter.emit("change", result);

    if(updateType === "update")
    {
      let changed = false;
      if(minPercent != this._minPercent) changed = true;
      if(maxPercent != this._maxPercent) changed = true;
  
      this._minPercent = minPercent;
      this._maxPercent = maxPercent;
      
    // console.log(`min ${minPercent}, max ${maxPercent}`);

      if(changed || forceUpdate) this.emitter.emit("update", result);
    }
  }
  

  
}

function setupDrag($target: JQuery, $related: JQuery, $base: JQuery, $value: JQuery, thehold: number)
{
  let ham = new Hammer($target[0], {});
  ham.get("pan").set({ direction: Hammer.DIRECTION_HORIZONTAL });

  let isDragging = false,
    startBound: DOMRect,
    relatedBound: DOMRect,
    baseBound: DOMRect,
    relatedPercent: number,
    startPercent,
    targetPercent: number;

  ham.on("panstart", (event: any) =>
  {
    isDragging = true;
    startBound = $target[0].getBoundingClientRect();
    relatedBound = $related[0].getBoundingClientRect();
    baseBound = $base[0].getBoundingClientRect();

    relatedPercent = (relatedBound.x - baseBound.x) / baseBound.width;
    startPercent = (startBound.x - baseBound.x) / baseBound.width;

    // console.log(startBound);
    // console.log(relatedX);
    // console.log(baseBound);

    // console.log(startPercent);
  });

  ham.on("pan", (event: any) =>
  {
    targetPercent = (startBound.x - baseBound.x + event.deltaX) / baseBound.width;
    if (targetPercent < 0) targetPercent = 0;
    if (targetPercent > 1) targetPercent = 1;
    if (thehold > 0) {
      if (targetPercent > relatedPercent - thehold) targetPercent = relatedPercent - thehold;

      $value.css("left", (targetPercent * 100) + "%").css("width", ((relatedPercent - targetPercent) * 100) + "%");
    }

    if (thehold < 0) {
      if (targetPercent < relatedPercent - thehold) targetPercent = relatedPercent - thehold;

      $value.css("width", ((targetPercent - relatedPercent) * 100) + "%");
    }

    $target.css("left", (targetPercent * 100) + "%");
    

    _update.call(this, "change");

  });

  ham.on("panend", (event: any) =>
  {
    isDragging = false;

    _update.call(this, "update");
  });

  function _update(updateType: string)
  {

    let basePercent = 1 - Math.abs(thehold);

    if (thehold > 0) {
      this.update(targetPercent / basePercent, (relatedPercent - Math.abs(thehold)) / basePercent, false, updateType);
    }
    else {
      this.update(relatedPercent / basePercent, (targetPercent - Math.abs(thehold)) / basePercent, false, updateType);
    }

  }
}